module.exports = __webpack_public_path__ + "static/outlander-mtg_clb-64b6177c2c5d58b2544d42cc3b06000e.jpg";